export default "__VITE_ASSET__y8BvacOl__"